import { HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";

export const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

export function handleHttpError<T>(_operation = "operation", result?: T) {
    return (_error: unknown): Observable<T> => {
        // TODO: send the error to remote logging infrastructure

        return of(result as T);
    };
}
